import { Box, Flex, Switch, Text } from "@mantine/core";
import { ACTIONS_LABELS } from "../../constants";
import {
  addAction,
  updateCurrentActions,
  useSelectCurrentActions,
} from "../../../../../redux/features/settings/settingsSlice";
import { useDispatch } from "react-redux";
import classes from "./actionsSwitches.module.scss";

const ActionsSwitches = ({ role }) => {
  const dispatch = useDispatch();
  const currentActions = useSelectCurrentActions();

  const handleChangeAction = (action, selected) => {
    const updateActionData = { action, role, selected };
    dispatch(updateCurrentActions(updateActionData));
    dispatch(addAction(updateActionData));
  };

  return (
    <Box mt="md">
      <Flex wrap="wrap" mah={400} direction="column">
        <Box
          className={classes["actions-box"]}
        >
          {currentActions.map(({ action, roles }, index) => {
            const currentActionState = roles.find(
              ({ role: r }) => r === role,
            )?.selected;

            return (
              <Box
                key={`${action}-${index}`}
                className={classes["action-item"]}
              >

                <Text truncate size="sm">{ACTIONS_LABELS[action]}</Text>

                <Switch
                  display="flex"
                  thumbIcon={" "}
                  checked={currentActionState}
                  labelPosition="left"
                  onClick={({ target: { checked } }) =>
                    handleChangeAction(action, checked)
                  }
                />
              </Box>
            );
          })}
        </Box>
      </Flex>
    </Box>
  );
};

export default ActionsSwitches;
